import { useRef } from "react";

type RefKey = string | number;

export const useRefDict = <T>() => {
  const refMap = useRef<{ [key: RefKey]: T }>({});

  const register = (key: RefKey) => (handle: T) => {
    refMap.current[key] = handle;
  };

  const get = (key: RefKey): Optional<T> => {
    return refMap.current[key];
  };

  return {
    get,
    register
  };
};
